module.exports = __webpack_public_path__ + "img/20180815_154807_240.edc7e512.jpg";